
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteAe as ObiOwnShipRemoteAeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-ae.js';
 
 
 

 
 export const ObiOwnShipRemoteAe = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-ae',
   elementClass: ObiOwnShipRemoteAeElement,
   events: {
     
   }
  });
 
 